import React, { useContext } from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails, Button } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { LayoutContext } from '../../../context/LayoutContext'
import Factories from './Factories'
import Brands from './Brands'
import Clients from './Clients'
import Status from './Status'
import DateRange from './DateRange'
import { defaultFormatTimeZone } from '../../../utils/consts'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'left',
      color: theme.palette.text.primary
    },
    container: {
      display: 'flex',
      justifyContent: 'flex-start'
    }
  })
)

export default function Filters (): JSX.Element {
  const classes = useStyles()
  const { setFilters } = useContext(FactoryFiltersContext)
  const { layout, setLayout } = useContext(LayoutContext)

  const handleChange = (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setLayout({
      isFilterOpen: isExpanded
    })
  }

  const cleanHandler = () => {
    setFilters({
      factory: [],
      brands: [],
      clients: [],
      newOrderStatus: [],
      orderCreatedAt: {
        initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
        finalDate: moment().clone().format('YYYY-MM-DD'),
        ...defaultFormatTimeZone
      }
    })
  }

  return (
    <div className={classes.root}>
      <Accordion className={classes.paper} expanded={layout.isFilterOpen} onChange={handleChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography paragraph>Filtros</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1} className={classes.container}>
            <Grid item container spacing={2} justifyContent="space-between" className={classes.item}>
              <Grid item sm={12} md={6}>
                <Factories />
              </Grid>
              <Grid item sm={12} md={6}>
                <Brands />
              </Grid>
              <Grid item sm={12} md={6}>
                <Clients />
              </Grid>
              <Grid item sm={12} md={6}>
                <Status />
              </Grid>
              <Grid item sm={12}>
                <DateRange />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent="flex-end" className={classes.item}>
              <Button color="secondary" onClick={cleanHandler}>limpar</Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
